export const args = {
    html: ` <p style='color:#667085;font-size:10px;font-weight: 400;line-height: 16px;'>
	  By proceeding, I accept  <span style='color:#1434CB;' >T&Cs, Privacy Policy</span>and<span style="color:#1434CB"; > Authorize</span> to Obtain my cKYC & credit report.
	  </p>`,
    //html: `<p style='color:#667085;font-size:10px;font-weight: 400;line-height: 16px;'>By proceeding, I accept  <span style='color:#1434CB;' >T&Cs, Privacy Policy</span>and<span style="color:#1434CB"; > Authorize</span> to Obtain my cKYC & credit report.</p>`,
};
export const argTypes = {};
